import React from 'react';
import { inject } from 'mobx-react';

import { SectionLayout } from 'layouts/section';

const styles = require('./terms-page.styles.scss');


@inject('analyticsStore')
export class TermsPage extends React.Component {
  componentDidMount() {
    this.props.analyticsStore.pageview('/terms');
  }

  render() {
    return (
      <div className={styles.TermsPage}>
        <SectionLayout>
          <h1>Nutzungsbedingungen</h1>
          <h2>Haftung für Inhalte und Links</h2>
          <p>
            Gemäß § 7 Abs.1 TMG ist der Webseiten-Betreiber für eigene Inhalte auf dieser Seite nach den allgemeinen Gesetzen verantwortlich. Die Webseite enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
          </p>
          <p>
            Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen. Deshalb distanzieren wir uns hiermit ausdrücklich von allen Inhalten aller gelinkten Seiten auf den gesamten Webseiten dieses Auftritts (Urteil vom 12. Mai 1998 - 312 O 85/98).
          </p>
        </SectionLayout>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/terms/terms.page.jsx